import { CUSTOM_TYPES } from '@/app/prismic/link-resolver'

export const JOB_BOARD = process.env.NUXT_ENV_PRISMIC_PROD
  ? 'form3'
  : 'form3test'
export const JOBS_URL = `https://api.greenhouse.io/v1/boards/${JOB_BOARD}/jobs`
export const DEPARTMENTS_URL = `https://api.greenhouse.io/v1/boards/${JOB_BOARD}/departments?render_as=tree`
export const JOBS_EMBED_SCRIPT = `https://boards.greenhouse.io/embed/job_board/js?for=${JOB_BOARD}`
export const JOB_EXCERPT_FIELD_ID = 15539406002
export const IS_JOB_PROMOTED_FIELD_ID = 15826981002
export const TEMPLATE_JOB_ID = 5811652002

export const sanitizeHtml = (data) => {
  const txt = document.createElement('textarea')
  txt.innerHTML = data

  return txt.value
}

export const getJobExcerpt = (job) => {
  if (!job || !job.metadata || job.metadata.length === 0) {
    return ''
  }

  const { value = '' } =
    job.metadata.find(({ id }) => id === JOB_EXCERPT_FIELD_ID) || {}

  return value?.replace(/[\u202F]/g, ' ') ?? ''
}

export const getCleanDepartments = (departments) => {
  return departments.reduce((acc, { id, name, jobs, children }) => {
    const hasChildrenJobs = children.some(({ jobs }) => jobs.length)

    if (jobs.length || hasChildrenJobs) {
      acc.push({
        id,
        name,
        jobs: getLatestJobs(jobs),
        children: children.length ? getCleanDepartments(children) : [],
      })
    }

    return acc
  }, [])
}

export const isPromotedJob = (job) => {
  if (!job || !job.metadata || job.metadata.length === 0) {
    return ''
  }

  const data = job.metadata.find(({ id }) => id === IS_JOB_PROMOTED_FIELD_ID)

  return data?.value
}

// filter out any template jobs
export const filterJobs = (jobList) =>
  jobList.filter(({ id }) => id !== TEMPLATE_JOB_ID)

export const sortJobs = (jobList) =>
  jobList.sort((a, b) => {
    if (a.updated_at > b.updated_at) {
      return -1
    } else if (a.updated_at < b.updated_at) {
      return 1
    }

    return 0
  })

export const getLatestJobs = (jobList, jobCount) => {
  const jobs = sortJobs(filterJobs(jobList))

  if (jobCount) {
    return jobs.slice(0, jobCount)
  }

  return jobs
}

export const getFilteredJobs = (departments, filters, parent) => {
  const { jobCategory, jobLocation, subCategories } = filters

  return departments.reduce((acc, department) => {
    acc.push(
      ...department.jobs.filter((job) => {
        if (jobLocation) {
          if (
            job.location?.name !== jobLocation &&
            parent?.location?.name !== jobLocation
          ) {
            return false
          }
        }

        if (subCategories?.length) {
          if (!subCategories.includes(department.name)) {
            return false
          }
        } else if (jobCategory) {
          if (department.name !== jobCategory && parent?.name !== jobCategory) {
            return false
          }
        }

        return true
      })
    )

    return department.children.length
      ? [...acc, ...getFilteredJobs(department.children, filters, department)]
      : acc
  }, [])
}

export const convertTitleToSlug = (title = '') =>
  title.trim().replace(/[\s\\\\/]+/g, '_')

export const getJobUrl = (job = {}) =>
  `${CUSTOM_TYPES.vacancies.url}/${job.id}/${convertTitleToSlug(job.title)}`

export const getJobCategory = (job = {}) =>
  job.departments && job.departments[0]?.name

export const getJobLocation = (job = {}) => job.location?.name

export const getJobsCategoryList = (jobs = []) => {
  return [...new Set(jobs.map(getJobCategory))]
}

export const getJobsLocationList = (jobs = []) => {
  return [...new Set(jobs.map(getJobLocation))]
}
